document.addEventListener('DOMContentLoaded', () => {

  /**
   * Using whatsapp button in the footer
   */
  const whatsappContainer = document.querySelector('[data-whatsapp-container]')
  const whatsappButton = document.querySelector('[data-whatsapp-button]')
  whatsappButton?.addEventListener('click', () => {
    whatsappContainer?.classList.toggle('open')
  })
})